module.exports = __webpack_public_path__ + "8f48612289.woff2";